import { formatErrorForSnackbar, toApiError } from '@/__core/helpers/Error';

export const handleBackendError = (error: any): string => {
  const apiError = toApiError(error);
  const formattedError = formatErrorForSnackbar(apiError);
  
  // If formatErrorForSnackbar returns default message, provide more specific fallbacks
  if (formattedError === 'An unexpected error occurred') {
    if (apiError.response?.status === 404) {
      return "Không tìm thấy đơn hàng để cập nhật";
    } else if (apiError.response?.status === 403) {
      return "Bạn không có quyền cập nhật đơn hàng này";
    } else if (apiError.response?.status === 400) {
      return "Dữ liệu gửi lên không hợp lệ";
    } else if (apiError.response?.status === 500) {
      return "Lỗi server, vui lòng thử lại sau";
    } else if ((error as any)?.code === "NETWORK_ERROR") {
      return "Lỗi kết nối mạng, vui lòng kiểm tra lại";
    } else {
      return "Có lỗi xảy ra khi cập nhật đơn hàng";
    }
  }
  
  return formattedError;
};
